export interface JournalAnswer {
  type: "text" | "audio";
  content: string;
}

export interface JournalPrompt {
  id: string;
  question: string;
  complexity: string;
  audio?: string;
  answer?: JournalAnswer;
}

export type InputMethod = "speak" | "write" | "";

export const JOURNAL_STRINGS = {
  mythoughts: "My thoughts",
  mythoughttoday: "My thoughts for today",
  saveYourWork: "Save your work?",
  noWorkToSave: "There's no work to save. \nLet's create something.",
  howToJournal: "How would you like to journal?",
  iWantTo: "I want to ",
  speak: "speak",
  write: "write",
  okay: "Okay!",
  startTyping: "Start typing...",
  thatsAmazing: "You did it! i loved your answer!",
  woohoo: "Thank you,Troo",
  own: "My idea",
  giveIdea: "Give me an idea",
  ownIdea: "Create my own idea",
  idea: "Suggest me",
} as const;
